import { render, staticRenderFns } from "./px-more-list.vue?vue&type=template&id=6d83589c&scoped=true&"
import script from "./px-more-list.vue?vue&type=script&lang=ts&"
export * from "./px-more-list.vue?vue&type=script&lang=ts&"
import style0 from "./px-more-list.vue?vue&type=style&index=0&id=6d83589c&lang=scss&scoped=true&"
import style1 from "./px-more-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d83589c",
  null
  
)

export default component.exports